var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"float-icon",style:(_vm.floatIconStyle),attrs:{"id":"float-icon"}},[_c('button',{staticClass:"close-button",on:{"click":_vm.closeFloatIcon}},[_vm._v("✖")]),_c('img',{attrs:{"src":"/build/assets/img/icons/banners/promotion.png","alt":"floating image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }